const _ = require('lodash');

const filterMultiLangInfos = (multiLangInfos) => {
  const obj = _.clone(multiLangInfos);
  _.unset(obj, 'en');
  _.unset(obj, 'local');

  return obj;
}

const transformMultiLangInfos = (nameObj, descObj) => {
  return _.merge(
    _.mapValues(filterMultiLangInfos(nameObj), (value) => { return { name: value } }),
    _.mapValues(filterMultiLangInfos(descObj), (value) => { return { description: value } })
  );
}

const isAnyMultiLangInfoEmpty = (multiLangInfos) => {
  const values = _.values(multiLangInfos);
  return _.findIndex(values, (value) => value === undefined || value.length === 0) >= 0;
}

const isAnyMultiLangNameOver40 = (multiLangInfos) => {
  const values = _.values(multiLangInfos);
  return _.findIndex(values, (value) => value.length > 40 ) >= 0;
}

module.exports = {
  filterMultiLangInfos,
  transformMultiLangInfos,
  isAnyMultiLangInfoEmpty,
  isAnyMultiLangNameOver40
}
